import { useContext, useMemo } from "react";

import { ChartThemeContext } from "@/providers/ChartThemeProvider";
import { DEFAULT_PALETTE_COLORS } from "@ark/shared";

export function useColorPickerPalettes(): readonly (readonly string[])[] {
  const ctx = useContext(ChartThemeContext);
  return useMemo(() => {
    const config = ctx?.config;
    const customColors = config?.customPalettes?.length
      ? config.customPalettes.filter((palette) => palette.colors.length > 0).map((palette) => palette.colors)
      : config?.customPalette?.colors?.length
        ? [config.customPalette.colors]
        : [];
    return [...customColors, DEFAULT_PALETTE_COLORS];
  }, [ctx]);
}
